import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { QuizResultService } from './quiz-result.service';
import { LoadingService } from 'src/app/share/services/loading.service';
import { HttpParams } from '@angular/common/http';
import { DynamicFieldModel } from '@share';
import { Validators } from '@angular/forms';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-quiz-result',
  imports: [DynamicTableComponent,CommonModule],
  templateUrl: './quiz-result.component.html',
  styleUrl: './quiz-result.component.scss'
})
export class QuizResultComponent implements OnInit, AfterViewInit {
  constructor(private readonly service:QuizResultService,  private loadingService: LoadingService, private cdr: ChangeDetectorRef) {

  }
  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }
  ngOnInit(): void {
    this.service.getWinner().subscribe(x=> console.log(x));
    let helperParms = new HttpParams()
      .set('page', -1)
      .set('pageSize', -1);
    let params = new HttpParams()
      .set('page', this.schema.pageIndex.toString())
      .set('pageSize', this.schema.pageSize.toString());
    this.loadData(params);

  }
  total: 0;
  schema = {
    name: "Quiz Result List",
    enableDelete: false,
    enableEdit: false,
    enableAdd: false,
    showAction:false,
    size: "middle",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px",
        isStickyRight:false,
        isStickyLeft:true,

      },
      {
        key: "createdBy.name",
        title: "User Name",
        type: "object",
        enableSearch: true,
        searchType: "input",
        width: "200px",
        isStickyRight:false,
        isStickyLeft:true,
      },
      {
        key: "createdBy.phone",
        title: "Phone No.",
        type: "object",
        enableSearch: true,
        searchType: "input",
        width: "150px",
        isStickyRight:false,
        isStickyLeft:false,
      },
      {
        key: "createdBy.region",
        title: "Region",
        type: "object",
        enableSearch: true,
        searchType: "input",
        width: "150px",
        isStickyRight:false,
        isStickyLeft:false,
      },
      {
        key: "quiz_name",
        title: "Quiz Name",
        type: "string",
        enableSearch: true,
        searchType: "input",
        width: "250px",
        isStickyRight:false,
        isStickyLeft:false,
      },
      {
        key: "is_winner",
        title: "Winner",
        type: "trophy",
        enableSearch: true,
        searchType: "select",
        width: "180px",
        isStickyRight:false,
        isStickyLeft:false,
        option: [{ value: '1', text: 'Winner' }, { value: '0', text: 'Not Winner' }]
      },
      
      {
        key: "result",
        title: "Marks",
        type: "number",
        enableSearch: true,
        //enableSort:true,
        searchType: "input",
        width: "100px",
        isStickyRight:false,
        isStickyLeft:false,
      },
      {
        key: "createdAt",
        title: "Created Date",
        type: "date",
        enableSearch: false,
        searchType: "input",
        width: "150px",
        isStickyRight:false,
        isStickyLeft:false,
      },
      {
        key: "result_generated_at",
        title: "Result Date",
        type: "date",
        enableSearch: false,
        searchType: "input",
        width: "150px",
        isStickyRight:false,
        isStickyLeft:false,
      }
    ]
  };
  fieldConfig: Array<DynamicFieldModel> = [
    {
      label: 'Name',
      name: 'name',
      type: 'input',
      sortOrder: 1,
      placeholder: '',
      required: true,
      autofocus: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Name required',
        },
      ],
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: ''
    },
    {
      label: 'Group Name',
      name: 'group_id',
      type: 'select',
      required: true,
      placeholder: 'Group Name',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Group Name required',
        },
      ],
    },
    {
      label: 'Main Category Name',
      name: 'maincategory_id',
      type: 'select',
      required: true,
      placeholder: 'Main Category Name',
      dependOn: 'group_id',
      optionUrl: 'categoryhierarchy/option',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Main Category Name required',
        },
      ],
    },
    {
      label: 'Category Name',
      name: 'category_id',
      type: 'select',
      required: true,
      placeholder: 'Category Name',
      dependOn: 'maincategory_id',
      optionUrl: 'categoryhierarchy/option',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Category Name required',
        },
      ],
    },
    {
      label: 'Item Category Name',
      name: 'subcategory_id',
      type: 'select',
      required: true,
      placeholder: 'Item Category Name',
      dependOn: 'category_id',
      optionUrl: 'categoryhierarchy/option',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Item Category Name required',
        },
      ],
    },
    // {
    //   label: 'Metric',
    //   name: 'itemmetric_id',
    //   type: 'select',
    //   placeholder: '',
    //   required: true,
    //   disableOnUpdate:true,
    //   validations: [
    //     {
    //       name: 'required',
    //       validator: Validators.required,
    //       message: 'Metric required',
    //     },
    //   ],
    // },

    {
      label: 'Price',
      name: 'price',
      type: 'number',
      sortOrder: 2,
      class: 'col-md-6',
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Price required',
        },
      ],
    },
  ];

  list: any[] = [];

  change(data: { [key: string]: any }) {
    let params = new HttpParams()
      //.set('searchValue',this.searchValue)
      .set('page', data['pageIndex'].toString())
      .set('pageSize', data['pageSize'].toString())
      .set('filterValue', JSON.stringify(data['filters']))
      .set('sort', JSON.stringify(data['sorts']));
    this.loadData(params);
  }

  loadData(param: HttpParams = null) {
    this.loadingService.toggleTableLoading()
    this.service.getItems(param).subscribe({
      next: x => {
        this.list = x.data;
        this.total = x.totalCount;
      },
      error: err => this.loadingService.toggleTableLoading(),
      complete: () => {
        this.loadingService.toggleTableLoading();
        this.cdr.detectChanges();
      }
    });
  }

  formEvent(data: any) {
 
  }
}
